<template>
  <motlet-neo :options="motletOptions">
    <template v-slot:content="{ props }">
      <line-chart :settings="settings" :motlet="props.motlet" :store-name="storeName" :active-increment="activeIncrement" />
    </template>
  </motlet-neo>
</template>

<script>
import { merge } from 'lodash';
// BEGIN::Added.by.KWShin.2024.03.11.
import bus from '@/utils/bus';
// FINISH::Added.by.KWShin.2024.03.11.
// BEGIN::Added.by.SHJ.2026.04.27.
import { api } from '@/api/common/instances';
// FINISH::Added.by.SHJ.2026.04.27.
import lineChartable from './lineChartable';

export default {
  mixins: [lineChartable],
  data() {
    return {
      motletOptions: {
        id: 'dv/abap/os/ntwk',
        title: 'dv.title.ntwk',
        monitor: { monitorCode: 'C_PCAP_OS_NTWK', eventCode: 'ABAP_OS_NTWK', points: 60 },
        settings: {
          chart: {
            use: true,
            field: {},
          },
        },
        xAxisPoints: {
          use: true,
          divider: true,
          ready: false,
          value: 60,
          default: 60,
        },
      },
      // Realtime 데이터 가공을 위한 임시 버퍼들.
      socketData: [],
      socketFlag: [],
    };
  },
  watch: {
    sstmId: {
      handler() {
        // BEGIN::Modified.by.KWShin.2024.03.11.
        // this.sendMessage();
        if (this.activeIncrement && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.03.11.
      },
    },
    activeIncrement: {
      immediate: true,
      handler(value) {
        // BEGIN::Modified.by.KWShin.2024.03.11.
        // if (value) this.sendMessage();
        if (value && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.03.11.
      },
    },
    // BEGIN::Added.by.SHJ.2026.05.13. 언어 변경 시 헤더 타이틀 재합성
    '$i18n.locale'() {
      const field = this.motletOptions.settings.chart.field;
      if (field && field.code) this.chartFieldChanged(field.code);
    },
    // FINISH::Added.by.SHJ.2026.05.13.
  },
  methods: {
    /**
     * Modified.by.KWShin.2024.03.11
     * 수정사항에 대한 Comment는 PcapCpu.vue의 동일부분을 참조할 것.2024.03.11.KWShin.
     */
    /*
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const bound = response.length < this.monitor.points ? response.length : this.monitor.points;
      const data = response.slice(response.length - bound).map(item => {
        return this.dataHandler(item.data, item.ctime, item.empty);
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        this.prepend(['packets', 'inPackets', 'outPackets', 'inkb', 'outKb', 'inErrors', 'outErrors', 'collisions']);
      }
    },
    */
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const data = response.map(rspn => {
        // rspn.data는 네트워크 카드 갯수만큼의 배열이다.
        return this.dataHandler({ ctime: rspn.ctime, data: rspn.data });
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        this.socketFlag = this.descendants.map(des => {
          return { id: des.id, arrived: false };
        });
        this.prepend(['packets', 'inPackets', 'outPackets', 'inkb', 'outKb', 'inErrors', 'outErrors', 'collisions']);
        // 데이터 수집이 안되고 있는 시스템이 있을 수 있으므로 this.data의 유무를 체크해야 한다.
        if (this.data && this.data.length > 0) {
          bus.$emit(`change:timestamp-${this.storeName}`, {
            eventCode: this.motletOptions.monitor.eventCode,
            timestamp: this.data[this.data.length - 1].ctime,
          });
        }
        // BEGIN::Added.by.SHJ.2026.04.27.
        // WS 버퍼가 차트 X축 개수(monitor.points)만큼 채우지 못한 경우 앞쪽 빈 구간을 DB에서 보충한다.
        this.backfillFromDb();
        // FINISH::Added.by.SHJ.2026.04.27.
      }
    },
    /**
     * Modified.by.KWShin.2024.03.11.
     */
    /*
    wsDataHandler(key, response, ctime, empty) {
      const data = this.dataHandler(response, ctime, empty);
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.socketData.forEach(s => {
          this.data.find(d => d.id == s.id).data.push(s.data);
        });
        this.socketData = [];
        this.prepop();
      }
    },
    */
    wsDataHandler(key, response, ctime) {
      // response는 네트워크 카드 갯수만큼의 배열이다.
      const socketData = this.dataHandler({ ctime: parseInt(ctime), data: response });
      const target = this.data.find(d => d.id == key.instId);
      if (target) {
        target.data.push(socketData);
        target.data.splice(0, 1);
      }

      const inst = this.socketFlag.find(i => i.id == key.instId);
      if (inst.arrived) {
        this.socketFlag.forEach(i => {
          if (i.arrived == false) {
            const target = this.data.find(d => d.id == i.id);
            if (target) {
              target.data.push({
                ctime: parseInt(ctime),
                stime: parseInt(ctime),
                packets: undefined,
                inPackets: undefined,
                outPackets: undefined,
                inkb: undefined,
                outKb: undefined,
                inErrors: undefined,
                outErrors: undefined,
                collisions: undefined,
              });
              target.data.splice(0, 1);
            }
          }
          if (i.id == key.instId) i.arrived = true;
          else i.arrived = false;
        });
      } else {
        inst.arrived = true;
      }
    },
    /**
     * Modified.by.KWShin.2024.03.11.
     */
    /*
    dataHandler(response, ctime, empty) {
      if (isEmpty(response)) response = [{ stime: ctime }];
      const data = {
        ctime: parseInt(ctime) - (parseInt(ctime) % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(response[0].stime),
        packets: '',
        inPackets: '',
        outPackets: '',
        inKb: '',
        outKb: '',
        inErrors: '',
        outErrors: '',
        collisions: '',
      };
      if (!empty) {
        data.packets = 0;
        data.inPackets = 0;
        data.outPackets = 0;
        data.inKb = 0;
        data.outKb = 0;
        data.inErrors = 0;
        data.outErrors = 0;
        data.collisions = 0;
        response.forEach(r => {
          data.packets += parseInt(r.packets);
          data.inPackets += parseInt(r.inPackets);
          data.outPackets += parseInt(r.outPackets);
          data.inKb += parseInt(r.inKb);
          data.outKb += parseInt(r.outKb);
          data.inErrors += parseInt(r.inErrors);
          data.outErrors += parseInt(r.outErrors);
          data.collisions += parseInt(r.collisions);
        });
      }
      return data;
    },
    */
    dataHandler(param) {
      const ctime = parseInt(param.ctime);
      const rtnData = {
        ctime: ctime - (ctime % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(param.data[0].stime),
        packets: 0,
        inPackets: 0,
        outPackets: 0,
        inKb: 0,
        outKb: 0,
        inErrors: 0,
        outErrors: 0,
        collisions: 0,
      };
      param.data.forEach(datum => {
        rtnData.packets += parseInt(datum.packets);
        rtnData.inPackets += parseInt(datum.inPackets);
        rtnData.outPackets += parseInt(datum.outPackets);
        rtnData.inKb += parseInt(datum.inKb);
        rtnData.outKb += parseInt(datum.outKb);
        rtnData.inErrors += parseInt(datum.inErrors);
        rtnData.outErrors += parseInt(datum.outErrors);
        rtnData.collisions += parseInt(datum.collisions);
      });
      return rtnData;
    },
    // BEGIN::Added.by.SHJ.2026.04.27.
    /**
     * WS 버퍼가 monitor.points 만큼 채워지지 않았을 때 DB에서 부족한 앞 구간을 조회해
     * 이미 비어있는 슬롯(packets===undefined)에만 값을 주입한다. 실제 WS 데이터는 덮어쓰지 않는다.
     */
    async backfillFromDb() {
      if (!this.data || this.data.length === 0) return;
      const firstInst = this.data[0].data;
      if (!firstInst || firstInst.length === 0) return;
      const realPoints = firstInst.filter(d => d.packets !== undefined && d.packets !== '');
      if (realPoints.length === firstInst.length) return;
      const beginYmdhms = firstInst[0].ctime;
      const endYmdhms = realPoints.length > 0 ? realPoints[0].ctime - this.monitor.cycle : firstInst[firstInst.length - 1].ctime;
      if (endYmdhms < beginYmdhms) return;
      const params = {
        beginYmdhms,
        endYmdhms,
        sstmId: this.sstmId,
        motletCode: this.monitor.monitorCode,
        ...this.dataParam,
      };
      try {
        const { data: results } = await api.get('/motlet-data/chart', { params });
        if (!results || results.length === 0) return;
        results.forEach(result => {
          const inst = this.data.find(d => d.id === result.key.instId);
          if (!inst) return;
          result.data.forEach(db => {
            const dbCtime = parseInt(db.ctime);
            const slot = inst.data.find(p => p.ctime === dbCtime);
            if (slot && (slot.packets === undefined || slot.packets === '')) {
              slot.packets = parseInt(db.packets);
              slot.inPackets = parseInt(db.inPackets);
              slot.outPackets = parseInt(db.outPackets);
              slot.inKb = parseInt(db.inKb);
              slot.outKb = parseInt(db.outKb);
              slot.inErrors = parseInt(db.inErrors);
              slot.outErrors = parseInt(db.outErrors);
              slot.collisions = parseInt(db.collisions);
              if (db.stime) slot.stime = parseInt(db.stime);
            }
          });
        });
      } catch (e) {
        // DB 조회 실패 시 차트는 WS 실시간 수신으로 점진적으로 채워지므로 무시한다.
        console.warn('[PcapNetwork] backfillFromDb failed', e);
      }
    },
    // FINISH::Added.by.SHJ.2026.04.27.
    sendMessage() {
      // BEGIN:Added.by.KWShin.2022.08.21.
      // 어흐... socketData가 어디선가 간섭을 받아 엉뚱한 값이 들어간다.
      // 그런 경우를 대비해 socket을 구독하기 직전에 초기화를 한 번 더해준다.
      this.socketData = [];
      // FINISH:Added.by.KWShin.2022.08.21.
      this.$websocket.realtime.send({
        requests: this.descendants.map(descendant => ({
          key: { name: 'pcapOsNtwk', sstmId: descendant.systemId, instId: descendant.id },
          fields: ['stime', 'packets', 'inPackets', 'outPackets', 'inKb', 'outKb', 'inErrors', 'outErrors', 'collisions'],
          // BEGIN::Added.by.KWShin.2024.03.11.
          bufferSize: this.monitor.points,
          // FINISH::Added.by.KWShin.2024.03.11.
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    /**
     * Added.by.KWShin.20204.03.07.
     * Comment는 PcapMmory.vue 를 참조할 것.
     */
    xPointsChanged(xPoints) {
      this.motletOptions.xAxisPoints.ready = true;
      this.motletOptions.xAxisPoints.value = xPoints;
      this.motletOptions.monitor.points = xPoints;
      this.setXAxisPoints(xPoints);
      this.setMonitor(this.motletOptions.monitor);

      if (this.activeIncrement) this.sendMessage();
    },
    /**
     * Added.by.KWShin.20204.03.11.
     * Comment는 PcapMmory.vue 를 참조할 것.
     */
    chartFieldChanged(code) {
      this.motletOptions.settings.chart.field = this.chartFields.find(f => f.code == code);
      this.setChartField(code);
      // 차트 항목이 변경되었으므로 서브타이틀을 바꾸어 준다.2026.06.16.
      this.motletOptions.subTitle = `(${this.motletOptions.settings.chart.field.text})`;
    },
  },
  created() {
    // BEGIN::Added.by.KWShin.2024.03.11.
    bus.$on(`update:xAxisPoints-${this.motletOptions.id}`, xAxisPoints => {
      bus.$emit(`update:activeIncrement`, false);
      this.xPointsChanged(xAxisPoints);
    });
    bus.$on(`update:chartFieldCode-${this.motletOptions.id}`, chartFieldCode => {
      this.chartFieldChanged(chartFieldCode);
    });
    // FINISH::Added.by.KWShin.2024.03.11.
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.11.
    bus.$off(`update:xAxisPoints-${this.motletOptions.id}`);
    bus.$off(`update:chartFieldCode-${this.motletOptions.id}`);
    // FINISH::Added.by.KWShin.2024.03.11.
  },
};
</script>
